module.exports = __webpack_public_path__ + "media/images/athletes/100-d70e3a9bd26dc5e50b99d2f88925c2a3.png";